interface BrandConfig {
  [key: string]: {
    allowedFacets: string[];
  };
}

const brandConfig: BrandConfig = {
  gap: {
    allowedFacets: ['size', 'style', 'sleeveLength', 'fit', 'rise', 'length'],
  },
  on: {
    allowedFacets: [
      'style',
      'size',
      'rise',
      'length',
      'sleeveLength',
      'fit',
      'legShape',
      'fabricMaterial',
      'performanceTechnology',
      'collection',
      'occasion',
      'supportType',
      'pregnancyStage',
      'panelType',
    ],
  },
  br: {
    allowedFacets: [],
  },
  at: {
    allowedFacets: [
      'size',
      'style',
      'activity',
      'length',
      'rise',
      'legShape',
      'supportType',
      'sleeveLength',
      'collection',
      'performanceTechnology',
      'details',
      'fabricMaterial',
    ],
  },
};

export default brandConfig;
